var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.site)?_c('section',{class:{'overflow-hidden': !_vm.logged}},[_c('navigation'),_vm._v(" "),_vm._t("default"),_vm._v(" "),(!_vm.logged)?_c('auth-reconnect'):_vm._e()],2):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-71b61087","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/layouts/default-layout.vue
// module id = null
// module chunks = 